import classNames from 'classnames';

import React, {
  forwardRef,
  ForwardRefExoticComponent,
  HTMLAttributes,
  ReactNode,
  RefAttributes,
} from 'react';

import { Typography } from '../typography';

import styles from './empty-states.scss';

type Props = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    title?: string | ReactNode;
    wrapTitle?: boolean;
    subtitle?: string | ReactNode;
    wrapSubtitle?: boolean;
    icon?: React.ReactNode;
    dataTestId?: string;
  };

const COMPONENT_ID = 'modulor-empty-states';

export const EmptyStates: ForwardRefExoticComponent<Props> = forwardRef<HTMLDivElement, Props>(
  (
    {
      title,
      wrapTitle,
      subtitle,
      wrapSubtitle,
      icon,
      dataTestId = COMPONENT_ID,
      className,
      children,
      ...rest
    },
    ref,
  ) => {
    return (
      <div
        className={classNames(className, styles['empty-state-block'])}
        ref={ref}
        data-component-name={COMPONENT_ID}
        data-id={dataTestId}
        data-testid={dataTestId}
        {...rest}>
        {icon}
        <div className={styles['typo-section']}>
          {typeof title === 'string' ? (
            <Typography
              variant="title-2-semibold"
              className={classNames(styles['title'], {
                [styles.wrap]: Boolean(wrapTitle),
              })}
              dataTestId={`${dataTestId}-title`}>
              {title}
            </Typography>
          ) : (
            title
          )}
          {typeof subtitle === 'string' ? (
            <Typography
              variant="body-regular"
              className={classNames(styles['sub-title'], {
                [styles.wrap]: Boolean(wrapSubtitle),
              })}
              dataTestId={`${dataTestId}-subtitle`}>
              {subtitle}
            </Typography>
          ) : (
            subtitle
          )}
        </div>
        <span data-testid={`${dataTestId}-content`}>{children}</span>
      </div>
    );
  },
);

EmptyStates.displayName = 'EmptyStates';
